export default __webpack_public_path__ + "static/media/logo4.aab8efc4.png";